import React from 'react'
import BasicCalendar from '../../common/basic-calendar'
import moment from 'moment'
import ListItem from '../../experience/details-card'
import useCalendar from './use-calendar'

const UserCourseCalendar = ({
    previewExperiences = [],
    itemComponent = ListItem,
    date = moment(),
    disabled,
    emptyDayMessage,
}) => {
    const {
        dateSelected,
        setDateSelected,
        courses,
        isLoadingCalendar,
        onGetDateLabelColor,
        onGetDateDotColor,
        onGetDateBackgroundColor
    } = useCalendar({
        date,
        insertions: previewExperiences,
        dateBackgroundColors: BasicCalendar.DateBackgroundColors,
        dateDotColors: BasicCalendar.DateDotColors,
        dateLabelColors: BasicCalendar.DateLabelColors
    })

    const renderCourse = (course, key) => {
        const Course = itemComponent
        return (<div key={key} style={{ paddingTop: '10px'}}><Course experience={course} /></div>)
    }

    const renderCourses = () => {
        const today = moment(dateSelected, 'YYYY-MM-DD')
        const todayCourses = courses.filter(c => moment(c.date).isSame(today, 'day'))

        if (!todayCourses.length ) {
            return (<React.Fragment>{emptyDayMessage}</React.Fragment>)
        }

        return todayCourses.map(renderCourse)

    }

    return (
        <div style={{ paddingTop: '10px' }}>
            <BasicCalendar
                disabled={disabled}
                loading={isLoadingCalendar}
                date={dateSelected}
                onDateClicked={setDateSelected}
                onGetDateLabelColor={onGetDateLabelColor}
                onGetDateDotColor={onGetDateDotColor}
                onGetDateBackgroundColor={onGetDateBackgroundColor}
            />
            <hr />
            <div>
                {renderCourses()}
            </div>
        </div>
    )
}

export default UserCourseCalendar